import React, { useEffect, useState } from "react";
import { BarGraph, CommonHeader, Loader } from '../../components/commons';

import { connect } from 'react-redux';
import { RootState } from '../../redux/rootReducers';
import moment from 'moment';

import {
    getInvoicingExpensesInsightsAction,
    getInvoicingRevenueInsightsAction,
    resetInsightsError,
    resetInsightsSuccess,
    resetInvoicingExpensesInsightsData,
    resetInvoicingRevenueInsightsData
}
    from '../../redux/insights';
import { InvoicingInsightsPayload } from "../../commonTypes/insightsTypes";
import { InvoicingInsightsType } from "../../redux/insights/insightTypes";
import { InsightCard, InsightsCounterCard } from '../../components/Insights';
import { GetInoviceListTypePayload } from "../../commonTypes/invoicingTypes";
import { getExpensesInvoiceListAction, getOtherEntriesListAction, getRevenueInvoiceListAction } from "../../redux/invoicing";


type AppProps = {
    expensesInvoiceList?: any;
    revenueInvoiceList?: any;
    history?: any;
    date?: any;
    token: string | null;
    fetching: boolean;
    success: number | null;
    error: string | null;
    statusCode: number | null;
    otherEntriesList: any;
    invoicingRevenueInsightsData: InvoicingInsightsType[] | [];
    invoicingExpensesInsightsData: InvoicingInsightsType[] | [];
    missingExpensesAttachmentCount: number | null;
    missingRevenueAttachmentCount: number | null;
    missingOthersAttachmentCount: number | null;
    dispatchGetInvoicingExpensesInsightsAction: (data: InvoicingInsightsPayload) => void;
    dispatchGetInvoicingRevenueInsightsAction: (data: InvoicingInsightsPayload) => void;
    dispatchResetInsightsErrorAction: () => void;
    dispatchResetInsightsSuccessAction: () => void;
    dispatchResetInvoicingRevenuInsightsData: () => void;
    dispatchResetInvoicingExpensesInsightsData: () => void;
    dispatchGetRevenueInvoiceListAction: (data: GetInoviceListTypePayload) => void;
    dispatchGetExpensesInvoiceListAction: (data: GetInoviceListTypePayload) => void;
    dispatchGetOtherEntriesListAction: (data: GetInoviceListTypePayload) => void;
}
const InsightsDashboard = ({
    history,
    date,
    token,
    fetching,
    success,
    error,
    statusCode,
    invoicingRevenueInsightsData,
    invoicingExpensesInsightsData,
    dispatchGetInvoicingExpensesInsightsAction,
    dispatchGetInvoicingRevenueInsightsAction,
    dispatchResetInsightsErrorAction,
    dispatchResetInsightsSuccessAction,
    dispatchResetInvoicingRevenuInsightsData,
    dispatchResetInvoicingExpensesInsightsData,
    dispatchGetOtherEntriesListAction,
    dispatchGetExpensesInvoiceListAction,
    dispatchGetRevenueInvoiceListAction,
    expensesInvoiceList,
    revenueInvoiceList,
    otherEntriesList,
    missingExpensesAttachmentCount,
    missingOthersAttachmentCount,
    missingRevenueAttachmentCount
}: AppProps) => {

    const client_code = history && history.location && history.location.state && history.location.state.client_code ? history.location.state.client_code : 0;

    // const client_code = 76;

    const company_name = history && history.location && history.location.state && history.location.state.company_name ? history.location.state.company_name : '';

    const [expensesMissingAttachmentCount, setExpensesMissingAttachmentCount] = useState<number>(0);
    const [revenueMissingAttachmentCount, setRevenueMissingAttachmentCount] = useState<number>(0);
    const [othersMissingAttachmentCount, setOthersMissingAttachmentCount] = useState<number>(0);

    const start_date = moment(date).subtract(60, 'd').format('DD-MM-YYYY');
    const end_date = moment(date).format('DD-MM-YYYY');

    useEffect(() => {
        dispatchResetInvoicingExpensesInsightsData();
        dispatchResetInvoicingRevenuInsightsData();
        if (token) {
            let finalRevenueData = {
                token,
                client_code: client_code,
                start_date: start_date,
                end_date: end_date
            }

            let finalExpensesData = {
                token,
                client_code: client_code,
                start_date: start_date,
                end_date: end_date,
            }

            let invoiceCountData = {
                token,
                client_code,
                offset: 0,
                limit: 10000,
            }

            dispatchGetRevenueInvoiceListAction(invoiceCountData);
            dispatchGetExpensesInvoiceListAction(invoiceCountData);
            dispatchGetOtherEntriesListAction(invoiceCountData);
            dispatchGetInvoicingRevenueInsightsAction(finalRevenueData);
            dispatchGetInvoicingExpensesInsightsAction(finalExpensesData);
        }
        dispatchResetInsightsErrorAction();
        dispatchResetInsightsSuccessAction();
    }, []);

    const revenueGraphData = invoicingRevenueInsightsData?.map((item: any) => {
        return item.invoice_value
    })

    const expensesGraphData = invoicingExpensesInsightsData?.map((item: any) => {
        return item.invoice_value
    })

    const redirectToInvoiceGraph = () => {
        history.push({
            pathname: `/insights/${ client_code }/invoice-graph`,
            state: { client_code, company_name },
        })
    }

    return (
        <div className="insights-dashboard">
            <CommonHeader
                title="Insights"
                client_code={client_code}
                company_name={company_name}
            />

            <div className="row mt-3">
                <div className="col-md-12">
                    <h5 className="mb-4 mt-4">Invoicing Insights</h5>
                </div>
                <div className="col-md-4">
                    <div className="mb-2">
                        <InsightsCounterCard
                            count={expensesInvoiceList?.total_count}
                            subHeading="Purchase Entries"
                            counterColor="#fac858"
                            otherCounter={missingExpensesAttachmentCount}
                            otherSubHeading="Missing Attachments"
                            onPress={redirectToInvoiceGraph}
                        />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="mb-2">
                        <InsightsCounterCard
                            count={revenueInvoiceList?.total_count}
                            subHeading="Receipts Entries"
                            counterColor="#91cc75"
                            onPress={redirectToInvoiceGraph}
                            otherCounter={missingRevenueAttachmentCount}
                            otherSubHeading="Missing Attachments"
                        />
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="mb-2">
                        <InsightsCounterCard
                            count={otherEntriesList?.total_count}
                            subHeading="Other Entries"
                            counterColor="#00B8D4"
                            otherCounter={missingOthersAttachmentCount}
                            otherSubHeading="Missing Attachments"
                        />
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <InsightCard
                        header='Expense Insights'
                        subHeader={`Data Range: ${ start_date } to ${ end_date }`}
                        showDetail={true}
                        legendName='Expenses'
                        seriesData={expensesGraphData}
                        xAxisData={
                            invoicingExpensesInsightsData?.map((item: any) => {
                                return moment(item.date).format('DD-MM-YYYY')
                            })
                        }
                        barColor={['#fac858']}
                        action={() => redirectToInvoiceGraph()}
                    />
                </div>

                <div className="col-md-6 mb-3">
                    <InsightCard
                        header='Receipt Insights'
                        subHeader={`Data Range: ${ start_date } to ${ end_date }`}
                        showDetail={true}
                        legendName='Sales/Receipts'
                        seriesData={revenueGraphData}
                        xAxisData={
                            invoicingRevenueInsightsData?.map((item: any) => {
                                return moment(item.date).format('DD-MM-YYYY')
                            })
                        }
                        action={() => redirectToInvoiceGraph()}
                        barColor={['#91cc75']}
                        xAxisName=''
                        yAxisName=''

                    />
                </div>


                <div className="col-md-6 mb-3 d-none">
                    <div className="card">
                        <div className="card-body">
                            <h4>Invoice Revenue</h4>
                            <BarGraph
                                legendName='Revenue'
                                seriesData={revenueGraphData}
                                xAxisData={
                                    invoicingRevenueInsightsData?.map((item: any) => {
                                        return moment(item.date).format('DD-MM-YYYY')
                                    })
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-3 d-none">
                    <div className="card">
                        <div className="card-body">
                            <h4>Invoice Expenses</h4>
                            <BarGraph
                                legendName='Expenses'
                                seriesData={expensesGraphData}
                                xAxisData={
                                    invoicingExpensesInsightsData?.map((item: any) => {
                                        return item.date
                                    })
                                }
                            />
                        </div>
                    </div>
                </div>


            </div>
            {fetching && <Loader />}
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    token: state.auth.token,
    fetching: state.insights.fetching,
    success: state.insights.success,
    error: state.insights.error,
    statusCode: state.insights.statusCode,
    invoicingRevenueInsightsData: state.insights.invoicingRevenueInsightsData,
    invoicingExpensesInsightsData: state.insights.invoicingExpensesInsightsData,
    revenueInvoiceList: state.invoicing.revenueInvoiceList,
    expensesInvoiceList: state.invoicing.expensesInvoiceList,
    otherEntriesList: state.invoicing.otherEntriesList,
    missingExpensesAttachmentCount: state.invoicing.missingExpensesAttachmentCount,
    missingRevenueAttachmentCount: state.invoicing.missingRevenueAttachmentCount,
    missingOthersAttachmentCount: state.invoicing.missingOthersAttachmentCount
})

const mapDispatchToProps = (dispatch: any) => ({
    dispatchGetInvoicingExpensesInsightsAction: (data: InvoicingInsightsPayload) =>
        dispatch(getInvoicingExpensesInsightsAction(data)),
    dispatchGetInvoicingRevenueInsightsAction: (data: InvoicingInsightsPayload) =>
        dispatch(getInvoicingRevenueInsightsAction(data)),
    dispatchResetInsightsErrorAction: () => dispatch(resetInsightsError()),
    dispatchResetInsightsSuccessAction: () => dispatch(resetInsightsSuccess()),
    dispatchResetInvoicingRevenuInsightsData: () => dispatch(resetInvoicingRevenueInsightsData()),
    dispatchResetInvoicingExpensesInsightsData: () => dispatch(resetInvoicingExpensesInsightsData()),
    dispatchGetRevenueInvoiceListAction: (data: GetInoviceListTypePayload) =>
        dispatch(getRevenueInvoiceListAction(data)),
    dispatchGetExpensesInvoiceListAction: (data: GetInoviceListTypePayload) =>
        dispatch(getExpensesInvoiceListAction(data)),
    dispatchGetOtherEntriesListAction: (data: GetInoviceListTypePayload) =>
        dispatch(getOtherEntriesListAction(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(InsightsDashboard);

